export var TestIds;
(function (TestIds) {
  TestIds["TEXTAREA"] = "annotation-text-area";
  TestIds["DELETE_ICON_BUTTON"] = "delete-annotation-icon-button";
  TestIds["ADD_ANNOTATION_LINK"] = "annotation-link";
})(TestIds || (TestIds = {}));